module.exports = __webpack_public_path__ + "img/face.1e01a2c0.jpg";